module.exports = {
  __depends__: [
    require(155)
  ],
  __init__: [ 'bpmnCopyPaste' ],
  bpmnCopyPaste: [ 'type', require(13) ]
};
